import { createContext, useContext } from 'react';
import type { PageConfig } from '../editor/types';

const PageConfigContext = createContext<PageConfig | null>(null);

export function PageConfigProvider({ config, children }: { config: PageConfig | null; children: React.ReactNode }) {
  return <PageConfigContext.Provider value={config}>{children}</PageConfigContext.Provider>;
}

export function usePageConfig(): PageConfig | null {
  return useContext(PageConfigContext);
}
